import React, { useState } from 'react';
import { EmailSettingsType } from './emailsettings.config';
import CustomTable from 'src/app/components/CustomTable/CustomTable';
import './style.scss';
import { nginrMessengerService } from 'src/app/services';

import { useTranslation } from 'react-i18next';
import { statusHelper } from 'src/app/helpers';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Button from 'antd/es/button/button';
import Select from 'antd/es/select';

const { Option } = Select;

const EmailSettingsTab: React.FC<EmailSettingsType> = () => {
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const [mailProvider, setMailProvider] = useState<string | null>('smtp');

  interface Column {
    title: string;
    dataIndex: string;
    key: string;
    render: (_: any, record: any) => JSX.Element;
  }

  const columnsMicrosoft: Column[] = [
    {
      title: 'Object ID',
      dataIndex: 'objectId',
      key: 'objectId',
      render: (_, record: any) => (
        <Form.Item
          name="objectId"
          initialValue={record.objectId}
          rules={[{ required: true, message: 'Object ID is required' }]}
        >
          <Input placeholder="Object ID" />
        </Form.Item>
      ),
    },
    {
      title: 'Client ID',
      dataIndex: 'clientId',
      key: 'clientId',
      render: (_, record: any) => (
        <Form.Item
          name="clientId"
          initialValue={record.clientId}
          rules={[{ required: true, message: 'Client ID is required' }]}
        >
          <Input placeholder="Client ID" />
        </Form.Item>
      ),
    },
    {
      title: 'Tenant ID',
      dataIndex: 'tenantId',
      key: 'tenantId',
      render: (_, record: any) => (
        <Form.Item
          name="tenantId"
          initialValue={record.tenantId}
          rules={[{ required: true, message: 'Tenant ID is required' }]}
        >
          <Input placeholder="Tenant ID" />
        </Form.Item>
      ),
    },
    {
      title: 'Client Secret',
      dataIndex: 'clientSecret',
      key: 'clientSecret',
      render: (_, record: any) => (
        <Form.Item
          name="clientSecret"
          initialValue={record.clientSecret}
          rules={[{ required: true, message: 'Client Secret is required' }]}
        >
          <Input.Password placeholder="Client Secret" />
        </Form.Item>
      ),
    },
  ];

  interface SMTPColumn {
    title: string;
    dataIndex: string;
    key: string;
    render: (_: any, record: any) => JSX.Element;
  }

  const columnsSMTP: SMTPColumn[] = [
    {
      title: t('administration.emailSettings.smtpServer'),
      dataIndex: 'smtpServer',
      key: 'smtpServer',
      render: (_, record: any) => (
        <Form.Item
          name="smtpServer"
          initialValue={record.smtpServer}
          rules={[{ required: true, message: t('general.required') || '' }]}
        >
          <Input placeholder={t('administration.emailSettings.smtpServer') || ''} />
        </Form.Item>
      ),
    },
    {
      title: t('administration.emailSettings.senderMail'),
      dataIndex: 'senderMailAddress',
      key: 'senderMailAddress',
      render: (_, record: any) => (
        <Form.Item
          name="senderMailAddress"
          initialValue={record.senderMailAddress}
          rules={[{ required: false, message: 'required' }]}
        >
          <Input placeholder={t('administration.emailSettings.senderMail') || ''} />
        </Form.Item>
      ),
    },
    {
      title: t('administration.emailSettings.senderPassword'),
      dataIndex: 'senderMailPassword',
      key: 'senderMailPassword',
      render: (_, record: any) => (
        <Form.Item
          name="senderMailPassword"
          initialValue={record.senderMailPassword}
          rules={[{ required: false, message: 'required' }]}
        >
          <Input.Password placeholder={t('administration.emailSettings.senderPassword') || ''} />
        </Form.Item>
      ),
    },
    {
      title: t('administration.emailSettings.serverPort'),
      dataIndex: 'serverPort',
      key: 'serverPort',
      render: (_, record: any) => (
        <Form.Item
          name="serverPort"
          initialValue={record.serverPort}
          rules={[{ required: true, message: t('general.required') || '' }]}
        >
          <Input placeholder={t('administration.emailSettings.serverPort') || ''} />
        </Form.Item>
      ),
    },
  ];

  const handleProviderChange = (value: string) => {
    setMailProvider(value);
    form.resetFields();
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const finalValues = {
        ...values,
        mailProvider,
        mailSubject: 'Etecube Notification',
      };
      const response = await nginrMessengerService.createCredentials(finalValues, { blockErrorHandler: true });

      if (response.data === 'OK') {
        statusHelper.displaySuccessStatusMessage(t('success.emailSettingsSaved'));
      }
    } catch (error) {
      console.error('Validation Failed:', error);
    }
  };

  return (
    <div id="emailSettingsContainer">
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('administration.emailSettings.mailProvider')}
          //   name="mailProvider"
          rules={[{ required: true, message: 'Please select a mail provider' }]}
        >
          <Select
            placeholder="Select Mail Provider"
            onChange={handleProviderChange}
            defaultValue={mailProvider}
            disabled
          >
            <Option value="smtp">SMTP</Option>
            {/* <Option value="microsoft">Microsoft</Option> */}
          </Select>
        </Form.Item>
        <CustomTable
          id="emailSettingsTable"
          dataSource={[{ key: '1' }]}
          columns={mailProvider === 'microsoft' ? columnsMicrosoft : columnsSMTP}
          scroll={{ x: 500 }}
        />
        <Button type="primary" onClick={handleSave} style={{ marginTop: 16 }}>
          {t('general.save')}
        </Button>
      </Form>
    </div>
  );
};

export default EmailSettingsTab;
